// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"160":"60b8bd7d","346":"795566d4","418":"3c4667c2"}[chunkId] + ".js";
};